<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateProductoProyectos"
    >
      <header class="m-the-modal-header">
        <h5>{{ modalTittle }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <div v-html="modalMessage"></div>
        <label class="a-checkbox-primary margin-top-large">
          <input
            v-model="notificar"
            class="a-checkbox-input-products-primary"
            :disabled="buttonPrimary.sending"
            name="notificar"
            type="checkbox"
          />
          <span class="a-checkbox-checkmark"></span>
          <span>Notificar por email a los alumnos de esta actualización.</span>
        </label>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction
          cancel-text="Cancelar"
          :disabled="buttonPrimary.sending"
        />
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductAssetsIncludedAssetsModal',

  data () {
    return {
      buttonPrimary: {
        action: '',
        behavior: '',
        class: '',
        sending: false,
        type: 'submit'
      },

      modalMessage: '',
      modalTittle: '',
      notificar: 0
    }
  },

  created () {
    this.setMessage()
  },

  methods: {
    setMessage () {
      switch (this.$modal.element.action) {
        case 'addAll':
          this.buttonPrimary.action = 'Incluir'
          this.buttonPrimary.behavior = 'save'
          this.buttonPrimary.class = 'a-button-products-primary'
          this.modalTittle = 'Incluir todos los cursos'
          this.modalMessage = `<p>Se incluirán todos los cursos, esta acción permitirá a los alumnos que compraron el producto <span class="font-weight-bold text-color-products-primary">${this.$modal.element.nombreProd}</span> acceder a ellos, incluso para las ventas nuevas, donde también se otorgará acceso completo.</p>`
          break
        case 'addOne':
          this.buttonPrimary.action = 'Incluir'
          this.buttonPrimary.behavior = 'save'
          this.buttonPrimary.class = 'a-button-products-primary'
          this.modalTittle = 'Incluir curso'
          this.modalMessage = `<p>¿Deseas incluir el curso <span class="font-weight-bold text-color-assets-primary">${this.$modal.element.proyecto.titulo}</span> al producto <span class="font-weight-bold text-color-products-primary">${this.$modal.element.nombreProd}</span>?</p><p>Esta acción hará que los alumnos que ya compraron este producto y los nuevos que vayan a comprarlo, <u>tengan acceso a esta nueva formación.</u></p>`
          break
        case 'removeAll':
          this.buttonPrimary.action = 'Quitar'
          this.buttonPrimary.behavior = 'delete'
          this.buttonPrimary.class = 'a-button-danger-primary'
          this.modalTittle = 'Quitar todos los cursos'
          this.modalMessage = `<p>Se quitarán todos los cursos, esta acción prohibirá a los alumnos que compraron el producto <span class="font-weight-bold text-color-products-primary">${this.$modal.element.nombreProd}</span> acceder a ellos.</p>`
          break
        case 'removeOne':
          this.buttonPrimary.action = 'Quitar'
          this.buttonPrimary.behavior = 'delete'
          this.buttonPrimary.class = 'a-button-danger-primary'
          this.modalTittle = 'Quitar curso'
          this.modalMessage = `<p>¿Deseas quitar el curso <span class="font-weight-bold text-color-assets-primary">${this.$modal.element.proyecto.titulo}</span> del producto <span class="font-weight-bold text-color-products-primary">${this.$modal.element.nombreProd}</span>?</p><p>Esta acción hará que los alumnos que ya compraron este producto y los nuevos que vayan a comprarlo, <u>ya no tendrán acceso a esta formación.</u></p>`
          break
      }
    },

    updateProductoProyectos () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$modal.element.notificar = +this.notificar
        this.$modal.updateData('updateProductoProyectos')
      }
    }
  }
}
</script>
